import { RouterModule, Routes } from "@angular/router";
import { CaseInsensitiveMatcher } from "../../shared/services/url-matcher/caseinsensitiveurlmatcher";
import { AppointmentListComponent } from "./list/appointment-list.component";
import { NgModule } from "@angular/core";

const routes:Routes=[
  {
    matcher:CaseInsensitiveMatcher('list'),
    component:AppointmentListComponent
  }
]


@NgModule({
  imports:[RouterModule.forChild(routes)],
  exports:[RouterModule]
})

export class AppointmentRoutingModule{}
